import React from 'react';

export default function TimelineItem({ title, subtitle, period, children }) {
  return (
    <div className="timeline-item">
      <div className="timeline-item-header">
        <div>
          <h3>{title}</h3>
          <p className="timeline-item-subtitle">{subtitle}</p>
        </div>
        {period && <span className="timeline-item-period">{period}</span>}
      </div>
      {children}
    </div>
  );
}
